import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ProceduresContext from "./ProceduresContext";
import CircularProgress from "@material-ui/core/CircularProgress";
import styled from "styled-components";

const DialogTitleContainer = styled.div`
  min-width: 500px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SelectContainer = styled.div`
  width: 60%;
  padding-top: 10px;
  padding-bottom: 30px;
`;

const revisionReasonOptions = [
  "",
  "Error in entry",
  "New version"
];

const Container = styled.div`
    min-width:453px;
    display:flex;
    flex-direction:column;
    height:300px !important;

    padding-bottom:8px;
`;

const ContainerHeader = styled.div`
    width:100%;
    color: white;
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
    padding:20px;
    height:66px;
    background-color:RGB(48, 74, 87);
    display:flex;
    align-items:center;
`;

export default function ReviseProcedureDialog() {
  const context = React.useContext(ProceduresContext);
  const [saving, setSaving] = React.useState(false);
  const [confirmed, setConfirmed] = React.useState(false);
  const [revisionReason, setRevisionReason] = React.useState("");

  if (!context.procedureToConfirmRevision) return null;

  return (
    <Dialog
      maxWidth='xl'
      open={true}
    // aria-labelledby="alert-dialog-title"
    // aria-describedby="alert-dialog-description"
    >
      <Container>
        <ContainerHeader>Revise Procedure?</ContainerHeader>
        {/* <DialogTitle id="alert-dialog-title">
          <DialogTitleContainer>
            <div>Revise Procedure?</div>
            {saving && <CircularProgress size={20} />}
          </DialogTitleContainer>
        </DialogTitle> */}
        <DialogContent style={{ padding: '24px 24px' }}>
          {!confirmed && (
            <DialogContentText style={{ fontFamily: 'Roboto', fontWeight: '500' }} id="alert-dialog-description">
              You are about to make a revision to this procedure.  <br />
              All projects using this procedure will be notified of the change. <br />
              <br />
              Do you still want to continue?
            </DialogContentText>
          )}
          {confirmed && (
            <>
              <DialogContentText style={{ fontFamily: 'Roboto', fontWeight: '500' }}>
                Select a reason from the drop-down menu.
              </DialogContentText>
              <SelectContainer>
                <Select
                  fullWidth
                  value={revisionReason}
                  onChange={event => setRevisionReason(event.target.value)}
                >
                  {revisionReasonOptions.map((value, index) => (
                    <MenuItem value={value} key={index}>{value}</MenuItem>
                  ))}
                </Select>
              </SelectContainer>
            </>
          )}
        </DialogContent>
        <DialogActions style={{ paddingRight: '16px' }}>
          <Button variant="contained"
            disabled={saving}
            onClick={() => {
              setConfirmed(false);
              setRevisionReason("")
              context.confirmRevision(null);
              context.editProcedure(null);
            }}
            color="primary"
          >
            CANCEL
          </Button>
          <Button variant="contained"
            disabled={saving || (confirmed && !revisionReason)}
            onClick={() => {
              if (!confirmed) {
                setConfirmed(true);
              } else {
                setSaving(true);
                context.saveProcedure(
                  { ...context.procedureToConfirmRevision, revisionReason },
                  success => {
                    setSaving(false);

                    if (success) {
                      context.editProcedure(null);
                      context.confirmRevision(null);
                    }
                  }
                );
              }
            }}
            color="primary"
            autoFocus
          >
            {confirmed ? `Revise Now` : `Continue`}
          </Button>
        </DialogActions>

      </Container>

    </Dialog>
  );
}
